import React, { useState, useEffect } from "react";
import { Typography, Icon, TextField, InputAdornment } from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import { updateProfile, hideError } from "../../redux/action";

import { allowedIdType } from "../../../utils/allowedIdType";

import {
  StepLabel,
  CustomInput,
  Dropdown,
  CountryItem,
  CustomButton,
  DefaultLoader,
} from "../../../components";
import styles from "../styles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

const TaxInfo = props => {
  const {
    loading,
    profile,
    countryList,
    updateProfile,
    history,
  } = props;

  let alphaNumericFormat = /^[a-zA-Z0-9]{0,20}$/;

  const CRS = profile?.identities.find(
    identity => identity.idTypeCd === "TAX" && identity.taxType === "CRS"
  );

  const [taxCountryList, setTaxCountryList] = useState([]);
  const [taxInfo, setTaxInfo] = useState(() => {
    return {
      otherMalaysia: Boolean(CRS) ? "Yes" : "No",
      taxIdNo: CRS?.idNo || "",
    };
  });
  const [isTaxCountryOpen, setTaxCountryOpen] = useState(false);
  const [selectedTaxCountry, setSelectedTaxCountry] = useState("");
  const [taxCountrySearch, setTaxCountrySearch] = useState("");
  const [taxCountrySearchOutput, setTaxCountrySearchOutput] = useState([]);

  const localIdentity = profile?.identities?.find(allowedIdType);

  useEffect(() => {
    if (countryList) {
      let sortedName = countryList.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      let sorted = sortedName.sort((a, b) => {
        return a.index < b.index ? -1 : 1;
      });
      setTaxCountryList(sorted?.filter(item => item?.code !== "MY"));
    }
  }, [countryList]);

  useEffect(() => {
    setTaxCountrySearchOutput([]);
    taxCountryList.filter(country => {
      if (country.name.toLowerCase().includes(taxCountrySearch.toLowerCase())) {
        setTaxCountrySearchOutput(prevState => [...prevState, country]);
      }
    });
  }, [taxCountrySearch]);

  useEffect(() => {
    if (profile) {
      setSelectedTaxCountry(
        CRS?.citizenship || ""
      );
    }
  }, [profile]);

  useEffect(() => {
    if (selectedTaxCountry && taxCountryList) {
      setTaxInfo(prevState => ({
        ...prevState,
        taxCountry: taxCountryList.find(
          countryItem => countryItem.code === selectedTaxCountry
        )
          ? taxCountryList.find(
              countryItem => countryItem.code === selectedTaxCountry
            ).name
          : "",
      }));
    }
  }, [selectedTaxCountry, taxCountryList]);

  const handleChangeTaxInfo = e => {
    const { name, value } = e.target;

    setTaxInfo(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectTaxCountry = id => {
    setSelectedTaxCountry(id);

    const ctry = taxCountryList.find(item => item.code === id);
    setTaxInfo({ ...taxInfo, taxCountry: ctry.name });

    let temp = [...taxCountryList];

    temp.forEach((item, index) => {
      if (item.code === id) {
        temp.splice(index, 1);
        temp.unshift(item);
      }
    });

    setTaxCountryList(temp);
    setTaxCountrySearch("");
    setTaxCountryOpen(false);
  };

  const handleUpdate = () => {
    const identities = [
      {
        idTypeCd: localIdentity?.idTypeCd, //R
        idNo: localIdentity?.idNo, //R
        citizenship: localIdentity?.citizenship, //R
      },
    ];

    const TIN = profile?.identities?.find(
      identity =>
        identity.idTypeCd === "TAX" && identity.taxType === "EInvoice"
    )?.idNo;

    if (TIN) {
      identities.push({
        idTypeCd: "TAX",
        idNo: TIN,
        citizenship: "MY",
        taxType: "EInvoice",
      });
    }

    if (taxInfo.otherMalaysia === "Yes") {
      identities.push({
        idTypeCd: "TAX", //R
        idNo: taxInfo.taxIdNo, //R
        citizenship: selectedTaxCountry, //R
        taxType: "CRS",
      });
    }

    const payload = {
      masterId: profile.masterId, //R
      email: profile.email, //R
      mobileNo: profile.mobileNo, //R
      fullName: profile.fullName, //R
      townOfBirth: profile.townOfBirth, //R
      dob: moment(profile.dob).format("YYYY-MM-DD"), //R
      race: profile.race, //R
      natureOfBusinessCd: profile.natureOfBusinessCd, //R
      occupationTypeCd: profile.occupationTypeCd, //R
      maritalStatusCd: profile.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile.sourceOfFundCd,
      investmentObjCd: profile.investmentObjCd,
      employerName: profile.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities,
      address: {
        line1: profile.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: profile.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: profile.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: profile.contacts.find(contact => contact.postCode).postCode, //R
        city: profile.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city, //R
        state: profile.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship, //R
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    // window.consoleLog(payload);
    updateProfile({ payloadData: payload, from: PROFILE });
  };

  const handleChangeTaxId = value => {
    if (alphaNumericFormat.test(value) || value === "") {
      setTaxInfo(prevState => ({
        ...prevState,
        taxIdNo: value,
      }));
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}
      {/* Tax Country List */}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight - maxHeight / 10}
        isOpen={isTaxCountryOpen}
        handleDismiss={() => setTaxCountryOpen(false)}
      >
        <div style={{ margin: "16px 16px 24px" }}>
          <Typography
            color="secondary"
            style={{ ...styles.baseFont, ...styles.dropdownTitle }}
          >
            Update Tax Country
          </Typography>
          {/* Search */}
          <div style={{ marginTop: "16px" }}>
            <TextField
              placeholder="Type country name here"
              variant="outlined"
              fullWidth
              value={taxCountrySearch}
              onChange={e => setTaxCountrySearch(e.target.value)}
              inputProps={{
                style: {
                  ...styles.baseFont,
                  padding: "12px 16px",
                  color: "#333",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <SearchOutlinedIcon
                      sx={{ cursor: "pointer", color: "#0091DA", fontSize:24 }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {/* Country List */}
          <div style={{ marginTop: "24px" }}>
            {taxCountrySearch.length > 0 ? (
              <>
                <CountryItem
                  country={taxInfo.taxCountry}
                  isSelected={selectedTaxCountry ? true : false}
                  containerStyles={{
                    borderBottom: "1px solid #C4C6C5",
                    paddingBottom: "24px",
                  }}
                />

                {taxCountrySearchOutput.map((item, index) => {
                  return (
                    <CountryItem
                      key={index}
                      country={item.name}
                      onClick={() => handleSelectTaxCountry(item.code)}
                    />
                  );
                })}
              </>
            ) : (
              <>
                {taxCountryList.map((item, index) => {
                  return (
                    <CountryItem
                      key={index}
                      country={item.name}
                      isSelected={selectedTaxCountry === item.code}
                      onClick={() => handleSelectTaxCountry(item.code)}
                      containerStyles={
                        selectedTaxCountry &&
                        index === 0 && {
                          borderBottom: "1px solid #C4C6C5",
                          paddingBottom: "24px",
                        }
                      }
                    />
                  );
                })}
              </>
            )}
          </div>
        </div>
      </Dropdown>

      <StepLabel
        title="Update Tax Resident Info"
        containerStyles={{
          margin: "16px 16px 24px",
          alignItems: "flex-start",
        }}
        onClick={() => history.back()}
      />
      <div style={{ margin: "0 16px" }}>
        <CustomInput
          label="Are you a tax resident of any country other than Malaysia"
          name="otherMalaysia"
          value={taxInfo.otherMalaysia}
          onChange={handleChangeTaxInfo}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        <CustomInput
          label="Tax Country"
          name="taxCountry"
          placeholder="Please select a country"
          value={taxInfo.otherMalaysia === "Yes" ? taxInfo.taxCountry : ""}
          onClick={() => setTaxCountryOpen(true)}
          isEdit={taxInfo.otherMalaysia === "Yes" ? true : false}
          isRequired={true}
          isDropdown={true}
        />
        <CustomInput
          label="Tax ID Number"
          name="taxIdNo"
          value={taxInfo.otherMalaysia === "Yes" ? taxInfo.taxIdNo : ""}
          onChange={e => handleChangeTaxId(e.target.value)}
          isEdit={taxInfo.otherMalaysia === "Yes" ? true : false}
          isRequired={true}
        />
      </div>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={
            taxInfo.otherMalaysia === "Yes"
              ? selectedTaxCountry.length > 0 &&
                taxInfo.taxIdNo.length > 0 &&
                taxInfo.taxIdNo.length <= 20
                ? false
                : true
              : false
          }
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
    countryList: state.goal.countryList,
  }),
  {
    updateProfile,
    hideError,
  }
);

export default compose(
  withRouter,
  withConnect
)(TaxInfo);
